import { render, staticRenderFns } from "./RunnerCommentsMobile.vue?vue&type=template&id=77ef229c&scoped=true&"
import script from "./RunnerCommentsMobile.vue?vue&type=script&lang=js&"
export * from "./RunnerCommentsMobile.vue?vue&type=script&lang=js&"
import style0 from "./RunnerCommentsMobile.vue?vue&type=style&index=0&id=77ef229c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ef229c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VBtn,VCard,VChip,VCol,VRow})
